import React from 'react';
import SelectField from 'components/pure/utils/form/SelectField';

const toOption = model => ({label: model.name, value: model.id});

export default props => (
  <SelectField
    placeholder="Select a department"
    options={props.departments.map(toOption)}
    hideResetButton={true}
    tether={true}
    {...props}
  />
);
